exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".container-main{padding:0 0 4rem;min-height:770px;display:block;box-sizing:border-box;max-width:100%;overflow-x:hidden}.skip{position:absolute;top:7.5rem;left:2rem;font-size:1rem;padding:.7rem;color:#005092;font-weight:700;border:none;border-radius:.2rem;background-color:#fff;box-shadow:0 .2rem .5rem .1rem rgba(0,0,0,.25);opacity:0}.skip:focus{opacity:1;z-index:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/layouts/main/main.component.scss
// module id = 705
// module chunks = 0